import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/cmore/ellipse_left.png";
import { StaticImage } from "gatsby-plugin-image";

const Resultcmore = () => {
  return (
    <div
      className="result_cmore p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Results<span>/Impact</span>
            </h2>
            <p>
              The successful collaboration between TekRevol and the client
              resulted in the development of a sophisticated e-commerce
              platform. The streamlined process from concept to execution
              empowered construction material stores and builders with
              user-friendly interfaces and robust functionalities. The platform
              has become an indispensable tool, enhancing efficiency and
              convenience in the procurement of construction-related goods.
            </p>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/cmore/results.png"
                alt="TekRevol"
                className="img-fluid d-none d-md-block"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1027}
              />
              <StaticImage
                src="../../../images/case-studies/cmore/resullt_mob.png"
                alt="TekRevol"
                className="img-fluid d-sm-block d-md-none"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1027}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Resultcmore;
